var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgModel = function SvgModel(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 83.3125,
    y1: 32.830502,
    x2: 83.3125,
    y2: 135.200058,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 18.8125,
    x2: 86,
    y2: 153.1875,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9083600"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 38.707031 20.476562 L 35.367188 18.546875 C 34.925781 18.292969 34.375 18.613281 34.375 19.121094 L 34.375 20.3125 L 28.125 20.3125 L 28.125 13.601562 L 23.898438 9.375 L 9.375 9.375 L 9.375 23.527344 L 13.589844 28.125 L 20.3125 28.125 L 20.3125 34.375 L 19.121094 34.375 C 18.613281 34.375 18.292969 34.925781 18.546875 35.367188 L 20.476562 38.707031 C 20.75 39.183594 21.4375 39.183594 21.710938 38.707031 L 23.640625 35.367188 C 23.894531 34.925781 23.574219 34.375 23.066406 34.375 L 21.875 34.375 L 21.875 28.125 L 28.125 28.125 L 28.125 21.875 L 34.375 21.875 L 34.375 23.066406 C 34.375 23.574219 34.925781 23.894531 35.367188 23.640625 L 38.707031 21.710938 C 39.179688 21.4375 39.179688 20.75 38.707031 20.476562 Z M 38.707031 20.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 37.042969 5.46875 L 5.46875 5.46875 L 5.46875 36.238281 L 12.933594 44.53125 L 44.53125 44.53125 L 44.53125 12.957031 Z M 41.863281 12.5 L 13.605469 12.5 L 8.136719 7.03125 L 36.394531 7.03125 Z M 7.03125 8.136719 L 12.5 13.605469 L 12.5 41.714844 L 7.03125 35.636719 Z M 14.0625 42.96875 L 14.0625 14.0625 L 42.96875 14.0625 L 42.96875 36.71875 L 39.84375 36.71875 L 39.84375 38.28125 L 42.96875 38.28125 L 42.96875 39.84375 L 38.28125 39.84375 L 38.28125 41.40625 L 42.96875 41.40625 L 42.96875 42.96875 Z M 14.0625 42.96875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/model.78edfd28.svg";
export { ForwardRef as ReactComponent };